<template>
    <div class="wrapper">
        <ul>
            <li
                class="d-flex"
                :style="{'color': textColor, 'font-weight': isBoldText ? 'bold' : 'normal'}" 
            >
                <div v-html="content.dsc_texto"></div>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    props: {
        content: Object,
        textColor: String,
        isBoldText: Boolean
    },
    data() {
        return {

        }
    },
    created() {

    },
}
</script>

<style lang="scss" scoped>
div.wrapper {
    width: 90%;
}
li {
    font-size: 1.3rem;
    // padding-left: 20px;
    line-height: 1.5rem;
}

ul li::before {
  content: "\2022";  /* Add content: \2022 is the CSS Code/unicode for a bullet */
  color: black; /* Change the color */
  font-size: 1.3em;
  padding-right: 1.2rem;
  font-weight: var(--sc-weight-bold); /* If you want it to be bold */
  display: inline-block; /* Needed to add space between the bullet and the text */
  width: 1.5em; /* Also needed for space (tweak if needed) */
  margin-left: -1.5em; /* Also needed for space (tweak if needed) */
}
</style>